import { MapStore } from "Utils/mobx";
import CompetitionTeam from "./CompetitionTeam";

export class CompetitionTeamStore extends MapStore<CompetitionTeam> {}

const competitionTeamStore = new CompetitionTeamStore();

export default competitionTeamStore;
